import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=a5c1eba8&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.scss?vue&type=style&index=0&id=a5c1eba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c1eba8",
  null
  
)

export default component.exports